
export default {
  data() {
    return {
      pageData: null,
      activeChildData: null,

      options: [
        {
          name: "osnovneInformacije",
          label: this.$t("label.personalInfo"),
          type: "checkbox",
        },
        {
          name: "dogadanjaNovosti",
          label: this.$t("label.eventsNews"),

          type: "checkbox",
        },
        {
          name: "dokumenti",
          label: this.$t("label.documents"),
          type: "checkbox",
        },
        {
          name: "galerija",
          label: this.$t("label.gallery"),
          type: "checkbox",
        },
        {
          name: "radnoVrijeme",
          label: this.$t("label.workingHours"),
          type: "checkbox",
        },
        {
          name: "nabava",
          label: this.$t("label.procurement"),
          type: "checkbox",
        },
        {
          name: "arhivaNabave",
          label: this.$t("label.procurementArchive"),
          type: "checkbox",
        },
        {
          name: "nadzorniOdbor",
          label: this.$t("label.supervisoryBoard"),
          type: "checkbox",
        },
      ],
    };
  },
  mounted() {
    this.getPageData();
  },
  methods: {
    async getPageData() {
      if (
        this.$parent &&
        this.$parent.$parent &&
        this.$parent.$parent.pageData
      ) {
        this.pageData = this.$parent.$parent.pageData;

        if (this.pageData.children && this.pageData.children.length) {
          this.setActiveChildDataOnMounted();
        }
      }
    },

    setActiveChild(child) {
      this.activeChildData = child;
      this.$scrollToTop();
    },

    returnComponent(item) {
      let chosenType;

      if (item.osnovneInformacije) {
        chosenType = "ui-custom-pages-types-osnovne-informacije";
      } else if (item.dogadanjaNovosti) {
        chosenType = "ui-custom-pages-types-dogadanja-novosti";
      } else if (item.dokumenti) {
        chosenType = "ui-custom-pages-types-dokumenti";
      } else if (item.galerija) {
        chosenType = "ui-custom-pages-types-galerija";
      } else if (item.radnoVrijeme) {
        chosenType = "ui-custom-pages-types-radno-vrijeme";
      } else if (item.nabava) {
        chosenType = "ui-custom-pages-types-nabava";
      } else if (item.arhivaNabave) {
        chosenType = "ui-custom-pages-types-arhiva-nabave";
      } else if (item.nadzorniOdbor) {
        chosenType = "ui-custom-pages-types-nadzorni-odbor";
      }

      return chosenType;
    },

    setActiveChildDataOnMounted() {
      if (this.$route.query && this.$route.query.tab) {
        this.activeChildData = this.pageData.children.filter(
          (child) => child.title === this.$route.query.tab
        )[0];
      } else {
        this.activeChildData = this.pageData.children[0];
      }
    },
  },
};
